// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-itinerary-section--day .lad-slider .swiper-slide,.lad-itinerary-section--day .lad-slider .swiper-slide img{min-height:300px;max-height:300px}@media (min-width:768px){.lad-itinerary-section--day .lad-slider .swiper-slide,.lad-itinerary-section--day .lad-slider .swiper-slide img{min-height:500px;max-height:500px}}.lad-itinerary-section--day .lad-slider .swiper-slide img{-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
